"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Grid = _interopRequireDefault(require("@mui/material/Unstable_Grid2/Grid2"));
var _Heading = _interopRequireDefault(require("../../elements/Heading/Heading"));
var _Button = _interopRequireDefault(require("../../elements/Button/Button"));
var _Link = _interopRequireDefault(require("../../elements/Link/Link"));
var _GridTwo = _interopRequireDefault(require("../../components/Grid/GridTwo/GridTwo"));
var _excluded = ["headingCopy", "subheadingCopy", "buttonLabel", "buttonUrl"];
var ContactUsCTA = function ContactUsCTA(_ref) {
  var headingCopy = _ref.headingCopy,
    subheadingCopy = _ref.subheadingCopy,
    buttonLabel = _ref.buttonLabel,
    buttonUrl = _ref.buttonUrl,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return _react.default.createElement(_GridTwo.default, Object.assign({
    display: "flex",
    alignItems: "center",
    textAlign: "center",
    justifyContent: "center"
  }, props), _react.default.createElement(_Grid.default, {
    xs: 10,
    md: 8
  }, _react.default.createElement(_Heading.default, {
    h1: true,
    pink: true
  }, " ", headingCopy, " ")), _react.default.createElement(_Grid.default, {
    xs: 10,
    md: 8
  }, _react.default.createElement(_Heading.default, {
    hsub: true,
    gray: true
  }, " ", subheadingCopy, " ")), _react.default.createElement(_Grid.default, {
    xs: 10,
    md: 8,
    style: {
      marginTop: '30px'
    }
  }, _react.default.createElement(_Link.default, {
    href: buttonUrl
  }, _react.default.createElement(_Button.default, {
    darkTeal: true
  }, " ", buttonLabel, " "))));
};
var _default = ContactUsCTA;
exports.default = _default;